'use strict';

/**
 * Module dependencies.
 */

var methods = [
  "reload",
  "identify",
  "suppress",
  "unsuppress",
  "trigger",
  "anonymous",
  "on",
  "once",
  "off",
  "track",
  "reset",
  "next",
  "end",
  "clean",
  "destroy",
  "theme",
  "instance",
]


const initMethods = (appToken = null) => {
  let Userpilot = {};
  methods.forEach(function (method) {
    Userpilot[method] = function (...args) {
      callOrQueue(method, args, appToken);
    };
  });

  return Userpilot;
}

var userpilotNodeScript,
  Userpilot = initMethods(),
  initializedUserpilot = 0,
  queue = {};

methods.forEach(method => {
  queue[method] = [];
});

/**
 * Initialize.
 *
 * http://help.userpilot.com/
 *
 * @api public
 */

Userpilot.initialize = function (appToken, data = {}) {
  if (appToken) {
    Userpilot.sdkV2 = data.distro === "2.0";
    Userpilot[appToken] = initMethods(appToken);
    !initializedUserpilot && this.load(appToken, data);
    initializedUserpilot = 1;
    Userpilot.sdkV2 && Userpilot.instance({token: appToken});
  }
};

Userpilot.clearQueue = function () {
  methods.forEach(method => {
    queue[method] = [];
  });
};

/**
 * Loaded?
 *
 * @api private
 * @return {boolean}
 */

Userpilot.loaded = function () {
  if (Userpilot.sdkV2) {
    return typeof window.userpilotV2SDKInitialization !== "undefined";
  }
  return typeof window.userpilot !== "undefined";
};

/**
 * Load the Userpilot library.
 *
 * @api private
 * @param {Function} callback
 */

function load(url, sri) {
  userpilotNodeScript = document.createElement('script');
  userpilotNodeScript.setAttribute("src", url);


  if (sri) {
    userpilotNodeScript.setAttribute("integrity", sri);
    userpilotNodeScript.setAttribute("crossorigin", "anonymous");
  }

  document.getElementsByTagName('head')[0].appendChild(userpilotNodeScript);

  methods.forEach(method => {
    if (queue[method].length > 0) {
      queue[method].forEach(item => {
        Userpilot[method](...(item.args || []));
      });
    }
  });
}

Userpilot.load = function (token, settings) {
  if (typeof window === "undefined") return;
  if (!settings) {
    settings = {};
  }

  const version = settings.version;
  const sri = version ? settings.sri : "";

  settings = { ...window.userpilotSettings, ...settings }
  settings.version = settings.version || 'v0';
  settings.endpoint = settings.endpoint || 'api.userpilot.io/socket/';
  settings.token = token;

  window.userpilotSettings = settings;

  let shim = settings.domain ? `https://${settings.domain}/sdk/latest.js` : `https://js.userpilot.io/sdk/latest.js`;

  if (sri) {
    shim = settings.domain ? `https://${settings.domain}/sdk/version/${version}/app.js` : `https://js.userpilot.io/sdk/version/${version}/app.js`;
  }

  load(shim, sri);

};

function callOrQueue(method, args, appToken) {
  const processMethod = () => {
    if (method === "instance") {
      if (appToken) {
        console.warn("Instance method not supported, use Userpilot.instance({token: appToken}) instead");
        return false;
      }
      window.userpilot[method](...args);
    } else if (appToken) {
      window.userpilot[appToken][method](...args);
    } else {
      window.userpilot[method](...args);
    }
  }
  if (Userpilot.loaded()) {
    if (window.userpilotV2SDKInitialization) {
      window.userpilotV2SDKInitialization.then(processMethod);
    } else {
      processMethod();
    }
  } else if (typeof userpilotNodeScript !== 'undefined') {
    userpilotNodeScript.addEventListener('load', function () {
      if (window.userpilotV2SDKInitialization) {
        window.userpilotV2SDKInitialization.then(processMethod);
      } else {
        processMethod();
      }
    });
  } else {
    queue[method].push({ args: args });
  }
}

if (typeof module !== 'undefined' && typeof module.exports !== 'undefined') {
  module.exports.Userpilot = Userpilot;
} else {
  window.Userpilot = Userpilot;
}
